import success from 'assets/icons/success.svg';
import error from 'assets/icons/warning.svg';

export const TYPES = { success: 'success', error: 'error' };

export const icons = { [TYPES.success]: success, [TYPES.error]: error };

export const successModalTexts = {
  title: {
    [TYPES.success]: 'Заявка отправлена!',
    [TYPES.error]: 'К сожалению, заявка не отправлена',
  },
  description: {
    [TYPES.success]:
      'Благодарим за заявку. <br /> В случае положительного решения наши специалисты свяжутся с вами в течение 3 рабочих дней по почте, указанной вами при заполнении заявки',
    [TYPES.error]: 'Попробуйте снова',
  },
};
